import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import ContentGrid from './components/ContentGrid';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FeatureGrid />
        <ContentGrid />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
      {/* WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '虫虫漫画',
            url: 'http://x21ta.cn/',
            description: '虫虫漫画作为最新最全的漫画官网，提供免费在线漫画阅读服务，资源权威且全面，更新同步，是漫画爱好者信赖的官方渠道。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'http://x21ta.cn/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '虫虫漫画 - 首页',
            description: '虫虫漫画 - 免费阅读的在线漫画平台，最新最全的漫画官网',
            url: 'http://x21ta.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '虫虫漫画',
            },
          }),
        }}
      />
    </>
  );
}